"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * convert a resource to json
 * for prop simply do a toString
 * for link simply get uri
 */
var DefaultSerializer = /** @class */ (function () {
    function DefaultSerializer() {
    }
    /**
     * parse a prop value to server comprehensible value
     */
    DefaultSerializer.prototype.parseProp = function (value) {
        return value === null ? undefined : value;
    };
    /**
     * parse a hal-resource to server comprehensible value
     */
    DefaultSerializer.prototype.parseResource = function (value) {
        return value ? value.uri.uri : undefined;
    };
    return DefaultSerializer;
}());
exports.DefaultSerializer = DefaultSerializer;
//# sourceMappingURL=hal-json-serializer.js.map